import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
// Components
import ReplaySection from 'components/presentational/ReplaySection';
import BeginBtn from 'components/presentational/BeginBtn';
import HomepageSVG from 'components/svg/HomepageSVG';
import GTMPush from 'components/GTMPush'

// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js';

// Files
import './homepage.scss';

const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedHomepage extends Component {
    constructor(props) {
        super(props);
        this.audio = React.createRef();

        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        this.props.setAudioToPlay('Homepage');
        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio);
    }

    handleReplayClick() {
        this.animateSection();
    }
  
    render() {
        return (
            <div className="homepage text-center">
            
                <GTMPush 
                  event="Begin" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="00" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                  
                <div className="container">
                    <HomepageSVG ref={this.image} className="homepage__image"/>

                    <h1 className="homepage__heading heading-1" ref={this.headline}>Your guide to your <br/>beneficiary claim</h1>

                    <div className="homepage__content" ref={this.content}>
                        <p>We understand that this is a difficult time, but we want you to know that we’ve created this experience to be as simple and straightforward as possible for you. 
                        We’ll do all we can to provide the support you need during this time. </p>
                    </div>
                    
                    <BeginBtn href="/beneficiary" title="Begin" />

                    <ReplaySection handleClick={this.handleReplayClick} />
                </div>

            </div>
        )
    }
}

const Homepage = connect(mapStateToProps, mapDispatchToProps)(ConnectedHomepage);

export default withRouter(Homepage)
